"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.sortForOptimalDisplay = sortForOptimalDisplay;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Sort themes in with alternating size to avoid overlapping labels caused by many small themes being close together
function sortForOptimalDisplay(themes) {
  var _$chain$sortBy$chunk$ = _lodash.default.chain(themes).sortBy(function (theme) {
    return theme.questionIds.length;
  }) // Order by question count
  .chunk(Math.ceil(themes.length / 2)) // Separate into 2 chunks (small and large respectively)
  .value(),
      _$chain$sortBy$chunk$2 = _slicedToArray(_$chain$sortBy$chunk$, 2),
      small = _$chain$sortBy$chunk$2[0],
      large = _$chain$sortBy$chunk$2[1];

  return _lodash.default.chain(_lodash.default.zip(small, large)) // Zip (interleave) the chunks into each other
  .flatten() // Flatten nested arrays caused by zip operation
  .filter(function (t) {
    return t;
  }) // Remove undefined items introduced by un-even zip operation
  .value();
}

var _default = {
  sortForOptimalDisplay: sortForOptimalDisplay
};
exports.default = _default;
//# sourceMappingURL=themes.js.map